"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppSearchSelect = exports.AppSearchSelectDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_search_select_1 = require("../entities/entity-search-select");
var use_entities_1 = require("../../hooks/use-entities");
var router_1 = require("@reach/router");
var lodash_1 = require("lodash");
var current_path_name_1 = require("../../utils/current-path-name");
var use_app_routes_1 = require("../../hooks/use-app-routes");
exports.AppSearchSelectDefaultProps = {
  variant: "chromeless",
  placeholder: "Search Platform...",
  autoFocus: true
};
// -------- Child Component Props -------->
// -------- Styles -------->
var SelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: text; \n\n    .shp--entity-search-select__value-container,\n    .shp--entity-search-select__placeholder {\n      cursor: text; \n    }\n  "], ["\n    cursor: text; \n\n    .shp--entity-search-select__value-container,\n    .shp--entity-search-select__placeholder {\n      cursor: text; \n    }\n  "])))
});
// -------- Components -------->
var My = {
  Select: (0, styled_components_1.default)(entity_search_select_1.EntitySearchSelect)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
var AppSearchSelect = function (props) {
  var className = props.className,
    onSelect = props.onSelect,
    selectProps = __rest(props, ["className", "onSelect"]);
  var entities = (0, use_entities_1.useEntities)();
  var from = (0, current_path_name_1.currentPathName)();
  var routes = (0, use_app_routes_1.useAppRoutes)();
  if (from === '/') {
    from = routes.homeReturn;
  }
  var searchableEntityTypeNames = (0, lodash_1.map)((0, lodash_1.pickBy)(entities, function (defn) {
    return defn.includeInSearch;
  }), function (defn) {
    return defn.name;
  });
  var onSelectChange = function (value) {
    var entity = value && value.entity;
    if (onSelect) {
      onSelect();
    }
    if (entity) {
      var defn = entities[entity.__typename];
      if (defn) {
        if (defn.routes.details) {
          (0, router_1.navigate)(defn.to(entity.slug));
        } else {
          (0, router_1.navigate)(defn.toUpdate(entity.id, "from".concat(from)));
        }
      }
    }
  };
  return react_1.default.createElement(My.Select, __assign({}, props, {
    onChange: onSelectChange,
    entityTypeNames: searchableEntityTypeNames,
    isSearchable: true
  }));
};
exports.AppSearchSelect = AppSearchSelect;
exports.AppSearchSelect.defaultProps = exports.AppSearchSelectDefaultProps;
var templateObject_1, templateObject_2;